module.exports = __webpack_public_path__ + "static/media/star.9388ea57.svg";